var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"tag is-success"},[_vm._v(" "+_vm._s(_vm.trueValue)+" ")]):_c('span',{staticClass:"tag is-warning"},[_vm._v(" "+_vm._s(_vm.falseValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }